.page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--kh-topbar-height));
}

.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 24px;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
  background: var(--kh-bg);
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: var(--kh-size-meta);
  font-weight: 600;
  color: #ffffff;
  text-decoration: none;
  padding: 5px 10px 5px 8px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.12);
  border: 0.5px solid rgba(255, 255, 255, 0.25);
  transition:
    background var(--kh-duration-fast),
    border-color var(--kh-duration-fast);
  white-space: nowrap;
}

.back-link:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.45);
}

.header-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tool-name {
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  color: #ffffff;
}

.badge {
  font-size: var(--kh-size-meta);
  padding: 2px 7px;
  border-radius: var(--kh-radius-badge);
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.75);
}

/* Body split */

.body {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* Left panel */

.left-panel {
  width: 380px;
  flex-shrink: 0;
  background: var(--kh-bg);
  border-right: 0.5px solid rgba(0, 0, 0, 0.15);
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
}

.panel-label {
  font-size: var(--kh-size-meta);
  font-weight: var(--kh-font-label);
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: var(--kh-ls-label);
  text-transform: uppercase;
  margin: 8px 0 2px;
  padding: 0 2px;
  font-weight: 700;
}

.panel-label:first-child {
  margin-top: 0;
}

.dropzone {
  border: 1.5px dashed rgba(255, 255, 255, 0.3);
  border-radius: var(--kh-radius-card);
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition:
    border-color 150ms,
    background 150ms;
  background: rgba(255, 255, 255, 0.06);
  user-select: none;
}

.dropzone:hover,
.dropzone--over {
  border-color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.12);
}

.dropzone-icon {
  width: 22px;
  height: 22px;
  color: rgba(255, 255, 255, 0.5);
}

.dropzone-text {
  font-size: var(--kh-size-body);
  color: rgba(255, 255, 255, 0.9);
  font-weight: var(--kh-font-label);
}

.dropzone-hint {
  font-size: var(--kh-size-meta);
  color: rgba(255, 255, 255, 0.5);
}

.file-input {
  display: none;
}

.file-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.file-chip {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 20px;
  padding: 3px 6px 3px 10px;
  font-size: var(--kh-size-meta);
  color: rgba(255, 255, 255, 0.9);
  max-width: 200px;
}

.file-chip-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-chip-remove {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 0 2px;
  flex-shrink: 0;
  opacity: 0.6;
}

.file-chip-remove:hover {
  opacity: 1;
}

.instructions-textarea {
  width: 100%;
  resize: none;
  border: 0.5px solid var(--kh-border-hover);
  border-radius: var(--kh-radius-card);
  padding: 10px 12px;
  font-family: var(--kh-font);
  font-size: var(--kh-size-body);
  color: var(--kh-text-primary);
  background: var(--kh-surface);
  outline: none;
  min-height: 80px;
  transition: border-color 150ms;
  overflow: hidden;
  line-height: 1.5;
}

.instructions-textarea:focus {
  border-color: var(--kh-blue);
  box-shadow: 0 0 0 3px rgba(46, 127, 204, 0.1);
}

.instructions-textarea::placeholder {
  color: var(--kh-text-muted);
}

.generate-button {
  margin-top: 4px;
  width: 100%;
  padding: 10px 16px;
  background: var(--kh-red);
  color: #fff;
  border: none;
  border-radius: var(--kh-radius-card);
  font-family: var(--kh-font);
  font-size: var(--kh-size-body);
  font-weight: 700;
  cursor: pointer;
  transition:
    opacity var(--kh-duration-fast),
    transform var(--kh-duration-base) var(--kh-ease-out),
    box-shadow var(--kh-duration-base) var(--kh-ease-out);
}

.generate-button:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(237, 25, 67, 0.35);
}

.generate-button:active:not(:disabled) {
  transform: scale(0.96);
  box-shadow: none;
  transition-duration: 60ms;
}

.generate-button:disabled {
  opacity: 1;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.5);
  cursor: default;
}

/* Right panel */

.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  background: var(--kh-surface);
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 40px;
}

.empty-icon {
  width: 40px;
  height: 40px;
  color: var(--kh-text-muted);
  opacity: 0.35;
}

.empty-headline {
  font-size: var(--kh-size-body);
  color: var(--kh-text-secondary);
  text-align: center;
  max-width: 280px;
  line-height: 1.5;
  margin: 0;
}

.spinner {
  width: 28px;
  height: 28px;
  border: 2.5px solid var(--kh-surface-2);
  border-top-color: var(--kh-blue);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Toolbar */

.toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 8px 16px;
  border-bottom: 0.5px solid var(--kh-border);
  flex-shrink: 0;
  background: var(--kh-surface);
}

.toolbar-btn {
  padding: 4px 8px;
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  font-family: var(--kh-font);
  font-size: var(--kh-size-body);
  color: var(--kh-text-secondary);
  cursor: pointer;
  transition:
    background 100ms,
    color 100ms;
  min-width: 28px;
  font-weight: var(--kh-font-label);
}

.toolbar-btn:hover {
  background: var(--kh-surface-2);
  color: var(--kh-text-primary);
}

.toolbar-btn--active {
  background: var(--kh-blue-dim);
  color: var(--kh-blue);
  border-color: rgba(46, 127, 204, 0.2);
}

.toolbar-btn--italic {
  font-style: italic;
}

.toolbar-sep {
  width: 1px;
  height: 16px;
  background: var(--kh-border);
  margin: 0 4px;
  flex-shrink: 0;
}

.toolbar-color-wrap {
  display: flex;
  align-items: center;
  gap: 2px;
}

.toolbar-color {
  width: 28px;
  height: 28px;
  padding: 2px;
  border: 1px solid var(--kh-border-hover);
  border-radius: 4px;
  background: none;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

.toolbar-color::-webkit-color-swatch-wrapper {
  padding: 0;
}

.toolbar-color::-webkit-color-swatch {
  border: none;
  border-radius: 2px;
}

.toolbar-select {
  height: 28px;
  padding: 0 4px;
  background: none;
  border: 1px solid transparent;
  border-radius: 4px;
  font-family: var(--kh-font);
  font-size: var(--kh-size-meta);
  color: var(--kh-text-secondary);
  cursor: pointer;
  transition:
    background 100ms,
    border-color 100ms;
}

.toolbar-select:hover {
  background: var(--kh-surface-2);
  border-color: var(--kh-border-hover);
}

/* Editor */

.editor-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 40px 48px;
}

.editor-content {
  max-width: 680px;
  margin: 0 auto;
}

.editor-scroll :global(.ProseMirror) {
  outline: none;
  font-size: var(--kh-size-body);
  color: var(--kh-text-primary);
  line-height: 1.7;
  min-height: 300px;
}

.editor-scroll :global(.ProseMirror) h1 {
  font-size: 1.75em;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0 0 20px;
  color: var(--kh-text-primary);
}

.editor-scroll :global(.ProseMirror) h2 {
  font-size: 1.3em;
  font-weight: 700;
  margin: 28px 0 12px;
  color: var(--kh-text-primary);
}

.editor-scroll :global(.ProseMirror) h3 {
  font-size: 1.05em;
  font-weight: 600;
  margin: 20px 0 8px;
  color: var(--kh-text-primary);
}

.editor-scroll :global(.ProseMirror) p {
  margin: 0 0 12px;
}

.editor-scroll :global(.ProseMirror) ul,
.editor-scroll :global(.ProseMirror) ol {
  padding-left: 24px;
  margin: 0 0 12px;
}

.editor-scroll :global(.ProseMirror) ul {
  list-style-type: disc;
}

.editor-scroll :global(.ProseMirror) ol {
  list-style-type: decimal;
}

.editor-scroll :global(.ProseMirror) li {
  margin-bottom: 4px;
}

.editor-scroll :global(.ProseMirror) strong {
  font-weight: 600;
}

/* Editor footer */

.editor-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 24px;
  border-top: 0.5px solid var(--kh-border);
  flex-shrink: 0;
  background: var(--kh-surface);
}

.footer-hint {
  font-size: var(--kh-size-body);
  color: var(--kh-text-muted);
}

.google-doc-button {
  padding: 8px 16px;
  background: var(--kh-blue);
  color: white;
  border: none;
  border-radius: var(--kh-radius-card);
  font-family: var(--kh-font);
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  cursor: pointer;
  transition: opacity 150ms;
}

.google-doc-button:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(46, 127, 204, 0.3);
}

.google-doc-button:active:not(:disabled) {
  transform: scale(0.97);
  box-shadow: none;
  transition-duration: 60ms;
}

.google-doc-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Streaming panel */

.streaming-panel {
  flex: 1;
  overflow-y: auto;
  padding: 40px 48px;
}

.streaming-text {
  max-width: 680px;
  margin: 0 auto;
  font-size: var(--kh-size-body);
  color: var(--kh-text-primary);
  line-height: 1.7;
  white-space: pre-wrap;
}

/* Doc created success state */

.doc-created-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 40px;
}

.doc-created-check {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--kh-teal-dim);
  color: var(--kh-teal);
  display: flex;
  align-items: center;
  justify-content: center;
}

.doc-created-check svg {
  width: 24px;
  height: 24px;
}

.doc-created-headline {
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  color: var(--kh-text-primary);
  margin: 0;
}

.gdoc-file-button {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border: 1px solid var(--kh-border-hover);
  border-radius: var(--kh-radius-card);
  background: var(--kh-surface);
  text-decoration: none;
  transition:
    border-color 150ms,
    box-shadow 150ms;
  width: 100%;
  max-width: 380px;
  cursor: pointer;
}

.gdoc-file-button:hover {
  border-color: #4285f4;
  box-shadow: 0 2px 12px rgba(66, 133, 244, 0.12);
}

.gdoc-file-icon {
  width: 32px;
  height: 42px;
  flex-shrink: 0;
}

.gdoc-file-meta {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.gdoc-file-name {
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  color: var(--kh-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gdoc-file-type {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
}

.gdoc-file-arrow {
  width: 16px;
  height: 16px;
  color: var(--kh-text-muted);
  flex-shrink: 0;
}

/* BubbleMenu */

.bubble-menu {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #1c1c1e;
  border-radius: 8px;
  padding: 6px 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.bubble-input {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 4px;
  padding: 4px 8px;
  font-family: var(--kh-font);
  font-size: var(--kh-size-body);
  color: white;
  outline: none;
  width: 200px;
  transition: border-color 150ms;
}

.bubble-input:focus {
  border-color: rgba(255, 255, 255, 0.35);
}

.bubble-input::placeholder {
  color: rgba(255, 255, 255, 0.35);
}

.bubble-submit {
  padding: 4px 10px;
  background: var(--kh-blue);
  color: white;
  border: none;
  border-radius: 4px;
  font-family: var(--kh-font);
  font-size: var(--kh-size-body);
  font-weight: var(--kh-font-label);
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 150ms;
}

.bubble-submit:hover:not(:disabled) {
  opacity: 0.88;
}

.bubble-submit:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
